module.exports = __webpack_public_path__ + "media/images/activeIconActivities-950b0d3e.png";